import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { GroupedSessions } from '@app/interfaces';
import { LeftNavigationService } from '../../services/left-navigation/left-navigation.service';
import { ChatStorageService } from '../../services/chat-storage/chat-storage.service';

@Component({
    selector: 'craig-chat-session-history',
    standalone: true,
    templateUrl: './chat-session-history.component.html',
    styleUrls: ['./chat-session-history.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatSessionHistoryComponent implements OnInit, OnDestroy {
    groupedChatSessions: GroupedSessions[] = [];
    private readonly componentDestroyed$: Subject<boolean> = new Subject();

    constructor(
        private readonly leftNavigationService: LeftNavigationService,
        private readonly chatStorageService: ChatStorageService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.groupedChatSessions = this.chatStorageService.getGroupedChatSessions();
        this.chatStorageService
            .chatSessionsListChange()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((isChatSessionsListChanged: boolean) => {
                if (isChatSessionsListChanged) {
                    this.groupedChatSessions = this.chatStorageService.getGroupedChatSessions();
                    this.changeDetectorRef.detectChanges();
                }
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next(true);
    }

    openChat(sessionId: number): void {
        this.leftNavigationService.selectChatSession(sessionId);
    }
}
